import * as React from "react";
import { FC } from "react";
import { Filter, FilterProps, SelectInput, TextInput } from "react-admin";
import { GetCarrierType } from "../../../../Enums/CarrierType";

export const CustomClearanceFilter: FC<Omit<FilterProps, "children">> = props => (
  <Filter {...props}>
    <TextInput label="Ref No" source="refNo__contains" alwaysOn />
    <TextInput label="Customer Po" source="customerPo__contains" alwaysOn />
    <TextInput label="Pn" source="customerRequestComponent__contains" alwaysOn />
    <TextInput label="Sn" source="unserviceable.sn__contains" alwaysOn />
    <TextInput label="Awb" source="unserviceable.awb__contains" alwaysOn />
    <SelectInput
      source="unserviceable.carrierEnum__eq"
      choices={GetCarrierType}
      label="Core Unit Forwarding Agency"
      optionText="Description"
      optionValue="Value"
      style={{ width: "285px" }}
      alwaysOn
      fullWidth
    ></SelectInput>
  </Filter>
);
